// In-memory access token for the JWT auth rewrite.
//
// The short-lived access token is held ONLY in memory (module variable) — never
// in localStorage/sessionStorage — so it isn't exposed to XSS or persisted to
// disk. Session continuity across reloads comes from the HttpOnly refresh cookie
// + a silent /auth/refresh on boot, not from a stored token or password.

let accessToken: string | null = null;

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string | null): void => {
    accessToken = token;
};

export const clearAccessToken = (): void => {
    accessToken = null;
};
